import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { reducer } from './reducer';
import { MapAttributionPreview } from './preview';
import { toggleOptional, changePosition } from './actions';
import { withSettings } from '../withSettings';
import { MapAttributionForm } from './form';
export const mapStateToProps = (state, props) => {
    return {
        ...state[props.componentIdent],
        isChecked: !state[props.componentIdent].isHidden,
    };
};
export const mapDispatchToProps = (dispatch, props) => {
    const componentIdent = props.componentIdent;
    return {
        onChange: (e) => {
            dispatch(changePosition(e.target.value === 'true', componentIdent));
        },
        onSwitchChange: props.isOptional
            ? (e) => {
                dispatch(toggleOptional(e.target.checked, componentIdent));
            }
            : undefined,
    };
};
export const MapAttributionPreviewContainer = compose(withReducer(reducer), connect(mapStateToProps, null))(MapAttributionPreview);
export const MapAttributionFormContainer = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings(MapAttributionForm));
//# sourceMappingURL=container.js.map